var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hideIfZero || _vm.totalCredits > 0)?_c('span',{staticClass:"badge badge--success"},[_vm._v(" "+_vm._s(_vm.$t('lms.user.total-credits-badge', [_vm.$n(_vm.totalCredits, 'twoDecimals')]))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }